var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6028 15.5357C28.4995 15.1423 28.2981 14.7835 28.0186 14.4953C27.7391 14.2071 27.3913 13.9994 27.0097 13.8929C25.6129 13.5 19.991 13.5 19.991 13.5C19.991 13.5 14.3689 13.5119 12.972 13.9048C12.5905 14.0112 12.2426 14.219 11.9631 14.5072C11.6836 14.7955 11.4822 15.1542 11.379 15.5477C10.9565 18.1072 10.7926 22.0072 11.3906 24.4643C11.4939 24.8577 11.6953 25.2165 11.9747 25.5047C12.2542 25.7929 12.6021 26.0007 12.9836 26.1071C14.3805 26.5 20.0025 26.5 20.0025 26.5C20.0025 26.5 25.6244 26.5 27.0212 26.1071C27.4028 26.0007 27.7506 25.793 28.0301 25.5047C28.3096 25.2165 28.511 24.8578 28.6143 24.4643C29.0599 21.9012 29.1973 18.0035 28.6028 15.5357Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2016 22.7856L22.8654 19.9999L18.2016 17.2142V22.7856Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.0ed9dd495a3128637f90d0c42d0b7cfe.svg";
export { ForwardRef as ReactComponent };